import React, { useEffect, useRef } from 'react';
import '../styles/Starfield.scss';

const Starfield = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const starCount = 100;

        for (let i = 0; i < starCount; i++) {
            const star = document.createElement('div');
            star.className = 'star';

            // Random position
            const x = Math.random() * 100;
            const y = Math.random() * 100;

            // Random size
            const size = Math.random() * 2;

            // Random delay
            const delay = Math.random() * 5;

            star.style.left = `${x}%`;
            star.style.top = `${y}%`;
            star.style.width = `${size}px`;
            star.style.height = `${size}px`;
            star.style.animationDelay = `${delay}s`;

            container.appendChild(star);
        }
    }, []);

    return <div className="starfield" ref={containerRef}></div>;
};

export default Starfield;
